import api from '@/api';

class Menu {
  static get() {
    return api.get('/menu');
  }
}

export default Menu;
